import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  noWorkouts: {
    marginTop: "16px",
    textAlign: "center",
    backgroundColor: "initial",
    width: "100%"
  }
});
